import dtos from '@/dtos/course';
import { CHANGE_DATE, FETCH_DAILY_COURSES } from './types';

export default {
    [CHANGE_DATE](state, payload) {
        state.date = payload.date;
    },
    [FETCH_DAILY_COURSES](state, payload) {
        const courses = payload.map(dtos.course);
        courses.sort((a, b) => {
            if (a.sequence > b.sequence) {
                return 1;
            }
            if (a.sequence < b.sequence) {
                return -1;
            }
            return 0;
        });

        state.courses = courses;
    },
};



// WEBPACK FOOTER //
// ./src/store/calendar/mutations.js